var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Map forms to { valuename: { value: "value" } } format required for input
// e.g. { country: { value: "Sweden" } }
export function formatSignupInput(values, { userType }) {
    const { emailAddress, password, pid, organizationNumber, country, externalId = '', externalAttributes = undefined, priceListAccessCode = undefined, dynamicContent = undefined, preferences = undefined, consents = [] } = values, rest = __rest(values, ["emailAddress", "password", "pid", "organizationNumber", "country", "externalId", "externalAttributes", "priceListAccessCode", "dynamicContent", "preferences", "consents"]);
    // Currently passing through country.code:country.name for the country
    // selector. This is a hack for now to get the code and name separately.
    const [countryCode, countryName] = country.split(':');
    const billingInput = {
        countryCode: { value: countryCode }
    };
    const rawValues = Object.entries(rest);
    for (const [field, value] of rawValues) {
        billingInput[field] = {
            value: field === 'country' ? countryName : value
        };
    }
    return {
        type: userType,
        billingAddress: billingInput,
        emailAddress,
        password,
        pid,
        organizationNumber,
        priceListAccessCode,
        externalAttributes,
        externalId,
        dynamicContent,
        preferences,
        consents
    };
}
//# sourceMappingURL=formatSignupInput.js.map